const isBlob = (src) => typeof src === 'string' && src.startsWith('blob:');

export default isBlob;
